import React, {useState, useEffect} from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './pages.css';
import apiClient from '../api';
import TariffModal from '../components/TariffModal';
import TariffTable from '../components/TariffTable';

const SettingsPage = () => {
  const navigate = useNavigate();
  const [serviceTemplates, setServiceTemplates] = useState([]);
  const [tariffs, setTariffs] = useState([]);
  const [isTariffModalOpen, setIsTariffModalOpen] = useState(false);
  const [editingTariff, setEditingTariff] = useState(null);

  const fetchServiseTemplates = async () => {
    // Заглушка для примера
    const templates = [
      { id: 1, name: 'Водоснабжение' },
      { id: 2, name: 'Электричество' },
      { id: 3, name: 'Газ' },
    ];
    setServiceTemplates(templates);
  };

  useEffect(() => {
    fetchServiseTemplates();
    fetchTariffs();
  }, []);

  const fetchTariffs = async () => {
    try {
      const tariffsRes = await apiClient.get('/tariffs');
      setTariffs(tariffsRes.data);
    } catch (err) {
      console.error('Ошибка загрузки тарифов:', err);
      alert('Не удалось загрузить тарифы');
    }
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleAddTariffClick = () => {
    setEditingTariff(null);
    setIsTariffModalOpen(true);
  };

  const handleEditTariff = (tariff) => {
    setEditingTariff(tariff);
    setIsTariffModalOpen(true);
  };

  const handleCloseTariffModal = () => {
    setEditingTariff(null);
    setIsTariffModalOpen(false);
  };

  const handleSaveTariff = async (payload, existingTariff) => {
    try {
      if (existingTariff) {
        const res = await apiClient.put(`/tariffs/${existingTariff.id}`, payload);
        const saved = res.data.tariff;
        setTariffs(prev => prev.map(t => t.id === saved.id ? saved : t));
      } else {
        const res = await apiClient.post('/tariffs', payload);
        const saved = res.data.tariff;
        setTariffs(prev => [saved, ...prev]);
      }
      setIsTariffModalOpen(false);
      setEditingTariff(null);
    } catch (err) {
      console.error('Ошибка сохранения тарифа:', err);
      alert('Не удалось сохранить тариф');
    }
  };

  return (
    <div className='page'>
      <div className='page-header'>
        <button 
          onClick={handleBackClick} 
          className='back-button'
        >
          ← Назад
        </button>    
        <h1>Настройки</h1>
      </div>

      <div className="table-actions" style={{ marginBottom: 12 }}>
        <button className="add-button" onClick={handleAddTariffClick}>Добавить тариф</button>
      </div>

      <TariffTable tariffs={tariffs} onEdit={handleEditTariff} />

      <TariffModal
        isOpen={isTariffModalOpen}
        onClose={handleCloseTariffModal}
        onSave={handleSaveTariff}
        tariff={editingTariff}
      />

    </div>
  );
};

export default SettingsPage;
